import { DateTime } from "luxon";

import { TableRow } from "./DataTable";
import { Order } from "../../types/Order";

type SortKey = string | number | DateTime | undefined;

function compareSortKeys(a: SortKey, b: SortKey): number {
  if (typeof a === "string" && typeof b === "string") return a.localeCompare(b);
  if (typeof a === "number" && typeof b === "number") return a - b;
  if (a instanceof DateTime && b instanceof DateTime) return a.toMillis() - b.toMillis();
  return 0;
}

export function sortTableRows<IDType>(
  rows: TableRow<IDType>[],
  sortField: string | undefined,
  sortDirection: Order | undefined
): TableRow<IDType>[] {
  if (!sortField || rows.length < 2) return rows;
  if (!rows[0].values.some(({ name }) => name === sortField)) return rows;

  const direction = sortDirection === "desc" ? -1 : 1;

  const decorated = rows.map(row => ({
    row,
    key: row.values.find(({ name }) => name === sortField)?.value as SortKey,
  }));

  decorated.sort((a, b) => compareSortKeys(a.key, b.key) * direction);

  return decorated.map(({ row }) => row);
}
